export default __webpack_public_path__ + "static/155-beb633d117571bfc8f57c44f15441fdb.jpg";